export var PriceAdjustmentType;
(function (PriceAdjustmentType) {
    PriceAdjustmentType[PriceAdjustmentType["PERCENTAGE"] = 1] = "PERCENTAGE";
    PriceAdjustmentType[PriceAdjustmentType["FLAT_RATE"] = 2] = "FLAT_RATE";
})(PriceAdjustmentType || (PriceAdjustmentType = {}));
//# sourceMappingURL=price-adjustment-type.js.map